<template>
  <div name="demo-orgchart-js" class="demo-orgchart-js">
    <div id="chart-container"></div>
  </div>
</template>

<script>
import OrgChart from 'assets/js/orgchart.js'
require('assets/css/orgchart.min.css')

let datascource = {
  id: '1',
  name: 'Lao Lao',
  secretary: [{
    id: 8,
    name: 'tao la'
  }, {
    id: 9,
    name: 'bo la'
  }],
  title: 'general manager',
  children: [{
    id: '2',
    name: 'Bo Miao',
    title: 'department manager'
  }, {
    id: '3',
    name: 'Su Miao',
    title: 'department manager',
    children: [{
      id: '4',
      name: 'Tie Hua',
      title: 'senior engineer'
    }, {
      id: '5',
      name: 'Hei Hei',
      title: 'senior engineer',
      children: [{
        id: '6',
        name: 'Pang Pang',
        title: 'engineer'
      }, {
        id: '7',
        name: 'Xiang Xiang',
        title: 'UE engineer'
      }]
    }]
  }, {
    id: '8',
    name: 'Yu Jie',
    title: 'department manager'
  }, {
    id: '9',
    name: 'Yu Li',
    title: 'department manager'
  }, {
    id: '10',
    name: 'Hong Miao',
    title: 'department manager'
  }, {
    id: '11',
    name: 'Yu Wei',
    title: 'department manager'
  }, {
    id: '12',
    name: 'Chun Miao',
    title: 'department manager'
  }, {
    id: '13',
    name: 'Yu Tie',
    title: 'department manager'
  }]
}

export default {
  name: 'demo-orgchart-js',
  mounted () {
    let orgchart = new OrgChart({
      chartContainer: '#chart-container',
      data: datascource,
      depth: 2,
      nodeContent: 'title',
      nodeID: 'id',
      createNode (node, data) {
        let secondMenu = document.createElement('div')
        secondMenu.innerHTML = `<img class="avatar" src="./static/images/orgchart/avatar/${data.id}.jpg">`
        node.appendChild(secondMenu)
        if (data.secretary !== undefined) {
          var i = 0
          // var x = ''
          let thirdMenuIcon = document.createElement('i')
          let thirdMenu = document.createElement('div')
          thirdMenuIcon.setAttribute('class', 'fa fa-info-circle')
          thirdMenuIcon.addEventListener('click', (event) => {
            event.target.nextElementSibling.classList.toggle('hidden')
          })
          thirdMenu.setAttribute('class', 'third-menu hidden')
          thirdMenu.innerHTML = ''
          for (;data.secretary[i];) {
            thirdMenu.innerHTML += `<img class="secretary" src="./static/images/orgchart/avatar/${data.secretary[i].id}.jpg">`
            i++
          }
          node.appendChild(thirdMenuIcon)
          node.appendChild(thirdMenu)
        }
      }
    })
    console.log(orgchart)
  }
}
</script>

<style lang="scss">
.demo-orgchart-js {
  #chart-container {
    position: relative;
    display: inline-block;
    top: 10px;
    left: 10px;
    height: 420px;
    width: calc(100% - 24px);
    border: 2px dashed #aaa;
    border-radius: 5px;
    overflow: auto;
    text-align: center;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .content {
    min-height: 20px !important;
  }

  .orgchart {
    background: #fff;
    .second-menu-icon {
      transition: opacity .5s;
      opacity: 0;
      right: -5px;
      top: -5px;
      z-index: 2;
      color: rgba(68, 157, 68, 0.5);
      font-size: 18px;
      position: absolute;
      &:hover {
        color: #449d44;
      }
    }
    .node {
      .second-menu {
        position: absolute;
        top: 0;
        right: -70px;
        border-radius: 35px;
        box-shadow: 0 0 10px 1px #999;
        background-color: #fff;
        z-index: 1;
      }
      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        float: left;
        margin-top: -75px;
        margin-left: 30px;
      }
      .content {
        height: 100px;
        line-height : 0px!important;
      }
      .third-menu {
        position: absolute;
        display: inline-flex;
        margin-top: -20px;
        margin-left: 20px;
      }
      .secretary {
        display: inline-block;
        width: 50px;
        height: 50px;
        border-radius: 30px;
        margin: 5px;
      }
      .hidden {
        display: none!important;
      }
      &:hover .second-menu-icon {
        opacity: 1;
      }
    }
  }

  #wrapper {
    width: 860px;
    margin: 0 auto;
    font-family: "Arial";
    li {
      margin-top: 20px;
    }
    a {
      font-size: 24px;
    }
    span {
      font-size: 24px;
    }
  }

  .fa-info-circle {
    position: absolute;
    margin-top: -20px;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// demoOrgchartJs.vue?1b5a9f4d